import { Component, Input, inject } from '@angular/core';

import { IProductTypeSize } from '@cakeiteasy/web-utils';

import { DiscountThemeService } from '../../services/discount-theme.service';

@Component({
  standalone: false,
  selector: 'ui-size-shape-info',
  templateUrl: './ui-size-shape-info.component.html',
  styleUrls: ['./ui-size-shape-info.component.scss']
})
export class UiSizeShapeInfoComponent {
  @Input() size: IProductTypeSize;
  @Input() currency = '';
  @Input() discount: number;

  protected discountTheme = inject(DiscountThemeService);
}
